/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Menueditoraddday3Inputs */

const en_menueditoraddday3 = /** @type {(inputs: Menueditoraddday3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.day}`)
};

const de_menueditoraddday3 = /** @type {(inputs: Menueditoraddday3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add {day}" |
*
* @param {Menueditoraddday3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditoraddday3 = /** @type {((inputs: Menueditoraddday3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditoraddday3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditoraddday3(inputs)
	return de_menueditoraddday3(inputs)
});
export { menueditoraddday3 as "menuEditorAddDay" }